
import { ThemeService } from '../../services/theme.service';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { httpHeaderInterceptor } from '../../configs/http.interceptor';
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { AppUrl } from '../../appUrl';
import { StorageService } from '../../services/storage-service';
import { TranslateModule } from '../../shareds/translate/translate.module';
import { TranslateService } from '../../shareds/translate/translate.service';
import { LanguageSwitcher } from '../../shareds/translate/language-switcher';

@Component({
  selector: 'app-confirm-email',
  standalone: true,
  imports: [ButtonModule, FormsModule, TranslateModule, LanguageSwitcher],
  templateUrl: './confirm-email.component.html',
  styleUrls: ['./confirm-email.component.css'],
})
export class ConfirmEmailComponent {
  form = {
    email: ''
  }
  submitted = false
  private translate = inject(TranslateService)
  protected theme = inject(ThemeService);

  constructor(private http: HttpClient,
    private ac: ActivatedRoute,
    private router: Router,
    private st: StorageService
  ) {
    let getEmail = JSON.parse(<any>this.st.getSession('refItem'))
    if (getEmail?.email) {
      this.form.email = getEmail?.email
      this.st.removeSession('refItem')
    }
  }

  get emailError(): string | null {
    if (!this.submitted) return null
    const email = this.form.email.trim()
    if (!email) return this.translate.instant('กรุณากรอกอีเมล', 'confirm-email')
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!emailRegex.test(email)) return this.translate.instant('รูปแบบอีเมลไม่ถูกต้อง', 'confirm-email')
    return null
  }

  cancel() {
    this.router.navigate(['/', AppUrl.list_room, this.ac.snapshot.params['app-id']])
  }

  sendEmail() {
    this.submitted = true
    if (this.emailError) return
    if (this.ac.snapshot.params['app-id']) {
      this.http.post('/api/Public/AuthHotel/Register/OTP', this.form).subscribe({
        next: (res: any) => {
          let model = res.data
          model.email = this.form.email
          sessionStorage.setItem('refItem', JSON.stringify(model))
          this.router.navigate(['/', AppUrl.verify, this.ac.snapshot.params['app-id']])
        }
      })
    }
  }
}
